var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOinqtip = function SvgOinqtip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Oinq Tip Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.814 171.506"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oinqtip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 319",
    fill: "none",
    d: "M0 0h124.712v126.375H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oinqtip_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1047",
    d: "M113.334 37.5h5.622s22.693-6.488 30.874-5.1a38.622 38.622 0 0 0-7.588-.6c-6.347 0-16.372 1.018-28.909 5.706",
    transform: "translate(-113.334 -31.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oinqtip_svg__c",
    x1: -1.135,
    y1: 17.808,
    x2: -1.125,
    y2: 17.808,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#242929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 377",
    width: 91.954,
    height: 91.954,
    rx: 19,
    transform: "rotate(23 13.667 130.022)",
    fill: "#67e29c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 58",
    d: "m14.771 38.307-2.11 8.229 8.229-2.111-7.311 4.326 7.311 4.326-8.229-2.111 2.111 8.229-4.326-7.311-4.328 7.313 2.111-8.229L0 53.078l7.311-4.326L0 44.425l8.229 2.111-2.111-8.229 4.326 7.311Z",
    fill: "#1c2451"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 59",
    d: "m59.535 150.617-2.11 8.229 8.229-2.111-7.311 4.326 7.311 4.326-8.229-2.111 2.111 8.229-4.326-7.311-4.328 7.313 2.111-8.229-8.229 2.11 7.311-4.326-7.311-4.327 8.229 2.111-2.111-8.229 4.326 7.311Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 378",
    width: 91.954,
    height: 91.954,
    rx: 25,
    transform: "rotate(-12.04 306.058 -135.826)",
    fill: "#c9ffdd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 455",
    transform: "translate(85.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 286",
    width: 80.077,
    height: 80.077,
    rx: 16,
    transform: "rotate(30 -56.915 95.328)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "@?",
    transform: "translate(79.645 93.342)",
    fill: "#d1d1d1",
    fontSize: 16,
    fontFamily: "Metropolis-ExtraBold, Metropolis",
    fontWeight: 800,
    letterSpacing: "-.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10,
    y: 0
  }, "@?")), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 53",
    d: "m30.848 0-2.11 8.229 8.229-2.111-7.311 4.326 7.311 4.326-8.229-2.111 2.111 8.229-4.326-7.311-4.328 7.313 2.111-8.229-8.229 2.11 7.311-4.326-7.311-4.327 8.229 2.111L22.195 0l4.326 7.311Z",
    fill: "#4db96e"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 527",
    clipPath: "url(#oinqtip_svg__a)",
    transform: "translate(52.029 12.566)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1036",
    d: "M115.437 31.654c4.829-6.554 11.6-24.309-.731-24.082-10.491.19-20.562 5.483-23.735 7.29-12.768-3.754-25.222-3.389-26.714-3.1a68.084 68.084 0 0 0-26.5 3.4C35.312 13.7 24.645 7.785 13.514 7.581c-12.656-.239-5.177 18.481-.345 24.57a53.515 53.515 0 0 0-3.87 5.63c-17.832 29.744-5.06 73.591 31.407 85.288 14.5 4.646 60.914 8.773 76.727-19.984 12.22-22.225 7.318-55.983-2-71.431",
    fill: "#4db96e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1037",
    d: "M115.436 31.654c4.386-5.969 10.4-21.2 2.138-23.731 6.269 4.774-1.075 18.643-5.414 16.844-3.674-1.283-12.165-7.23-19.048-11.069-.881.453-1.608.855-2.135 1.159h-.037c7.2 4.273 18.471 10.89 20.883 17.627 9.014 25.168 9.738 47.985-5 69.855-9.347 13.858-28.545 18.094-43.061 19.268a81.783 81.783 0 0 1-35.377-4.189 55.84 55.84 0 0 0 12.321 5.651c14.5 4.646 60.914 8.773 76.727-19.984 12.22-22.225 7.318-55.983-2-71.431",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1038",
    d: "M44.021 15.779a85.29 85.29 0 0 0-18.812 9.383c-7.944 5.305-16.147 13.093-18.912 23.49-5.008 18.749 2.673 45.715 19.692 57.529s54.714 9.756 67.1-2.424c15.828-15.565 7.548-28.951-3.458-29.514 0 0-14.231-6.214-19.571-.037-2.672 3.856-14.691 4.624-15.693-1.539-2.668-3.593-7.925-1.053-20.028 2.694-5.37 1.649-15.605-12.608-3.177-22.477 15.459-12.275 60.315-10.115 69.844 7.432 7.2 13.24 10.685-28.7-5.341-36.92s-34.617-10.184-51.644-7.617",
    fill: "#6fc282"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1039",
    d: "M99.445 20.717s10.272 6.945 11.785 9.665c2.413-.3 6.039-10.875 5.436-14.5s-10.868-2.705-17.221 4.836",
    fill: "#6fc282"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1040",
    d: "M116.665 15.892a1.989 1.989 0 0 0-.928-1.349c-.344 3.677-1.155 9.387-4.752 10.041-3.381.753-7.845-2.672-10.8-4.69-.252.271-.5.545-.731.833 0 0 10.272 6.945 11.785 9.665 2.405-.3 6.031-10.875 5.428-14.5",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1041",
    d: "M51.163 31.283a1.024 1.024 0 0 1-.536-.144 2.12 2.12 0 0 1-.551-.446c-7.592-8.387-11.552-4.074-11.715-3.89a.476.476 0 0 1-.281.153.793.793 0 0 1-.382-.039 1.951 1.951 0 0 1-.827-.6 2.373 2.373 0 0 1-.508-.968.866.866 0 0 1 .109-.765c.056-.056 5.177-5.643 14.582 4.752a2.4 2.4 0 0 1 .521.934.948.948 0 0 1-.057.777.5.5 0 0 1-.356.238",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1042",
    d: "M17.087 45.084a.54.54 0 0 1-.382.136.579.579 0 0 1-.423-.423 1.882 1.882 0 0 1-.066-.9c2.077-12.487 8.712-12.611 8.776-12.611a.407.407 0 0 1 .262.1.724.724 0 0 1 .2.28 1.441 1.441 0 0 1 .1.419 2.167 2.167 0 0 1-.011.494 2.379 2.379 0 0 1-.121.494 1.858 1.858 0 0 1-.212.419 1.056 1.056 0 0 1-.271.28.518.518 0 0 1-.288.1c-.219.005-5.343.154-7.015 10.175a2.248 2.248 0 0 1-.209.616 1.293 1.293 0 0 1-.336.425",
    fill: "#058e37"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1043",
    d: "M25.559 59.96c3.569 0 6.463-4.352 6.463-9.721s-2.894-9.721-6.463-9.721-6.463 4.352-6.463 9.721 2.894 9.721 6.463 9.721",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1044",
    d: "M30.854 47.137c.421 2.664.512 7.63-3.579 11.043a3.236 3.236 0 0 0 2.531-.837 6.244 6.244 0 0 0 1.774-2.841 9.594 9.594 0 0 0 .4-3.851 8.3 8.3 0 0 0-1.121-3.514",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1045",
    d: "M27.338 49.332c.921 0 1.668-1.123 1.668-2.509s-.747-2.508-1.668-2.508-1.668 1.123-1.668 2.508.747 2.509 1.668 2.509",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 529",
    clipPath: "url(#oinqtip_svg__b)",
    transform: "translate(93.457 24.188)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 320",
    transform: "translate(0 -.782)",
    fill: "url(#oinqtip_svg__c)",
    d: "M0 0h36.497v6.488H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 531",
    clipPath: "url(#oinqtip_svg__a)",
    transform: "translate(52.029 12.566)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1048",
    d: "M45.862 17.283s16.907-4.579 25.456-5.316 2.179-.062 2.179-.062-20.9 3.782-23.58 5.871Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1049",
    d: "M37.937 16.971s16.907-4.355 25.456-5.057 2.179-.058 2.179-.058-20.9 3.6-23.58 5.584Z",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1050",
    d: "M39.421 58.399c5.764 0 10.436-6.443 10.436-14.389s-4.673-14.39-10.436-14.39-10.436 6.443-10.436 14.39 4.673 14.389 10.436 14.389",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1052",
    d: "M43.09 46.677c2.027 0 3.67-2.266 3.67-5.06s-1.643-5.059-3.67-5.059-3.67 2.265-3.67 5.059 1.643 5.06 3.67 5.06",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1053",
    d: "M14.669 57.854S2.936 63.303.349 76.277c-1.87 9.064 3.8 20.6 16.32 16.222s19.841-5.694 27.4-5.274 17.67-3.335 18.325-9.881-1.628-16.208-11.055-21.06-22.452-6.271-36.67 1.57",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1054",
    d: "M2.979 80.857s.921 10.738 11.023 9.334 15.208-5.831 32.033-6.164 15.591-11.32 11.09-18.99-17.459-12.446-30.249-9.808S2.716 66.593 2.979 80.857",
    fill: "#4db96e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1055",
    d: "M17.524 76.468c.332 2.394-1.073 4.57-3.142 4.855s-4.006-1.423-4.341-3.817 1.073-4.574 3.137-4.858 4.013 1.422 4.346 3.82",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1056",
    d: "M18.967 77.476c.332 2.394-1.073 4.57-3.138 4.858s-4.009-1.422-4.342-3.82 1.073-4.57 3.137-4.858 4.01 1.426 4.342 3.82",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1057",
    d: "M50.16 70.455c.333 2.4-1.091 4.577-3.138 4.858s-4.009-1.422-4.341-3.817 1.069-4.573 3.138-4.858 4.009 1.422 4.341 3.817",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1058",
    d: "M51.606 71.466c.332 2.394-1.073 4.57-3.141 4.859s-4.01-1.422-4.342-3.82 1.073-4.57 3.137-4.858 4.007 1.411 4.346 3.82",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1059",
    d: "M40.488 55.905s-9.567-1.633-12.669 1.645c-.583 1.49 4.049 4.188 9.616 3.224s6.862-4.851 3.054-4.869",
    fill: "#a6d7b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1060",
    d: "M91.226 94.762s-14.008-5.363-18.553-10.051c0 0-4.961-1.978-4.994 3.1-4.921 1.8-2.59 6.486.7 10.452s25.354 20.724 32.182 19.686 7.345-14.542 7.345-14.542-.192-3.4-16.679-8.642",
    fill: "#4db96e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1061",
    d: "M91.226 94.762s-14.008-5.363-18.553-10.051c0 0-4.961-1.978-4.994 3.1-4.921 1.8-2.59 6.486.7 10.452a26.922 26.922 0 0 0 2.81 2.7c2.126-4.494 5.271-7.74 9.82-5.879 5.489 2.193 6.624 10.565 6.4 17.638 5.364 3.264 10.449 5.642 13.15 5.229 6.828-1.038 7.345-14.542 7.345-14.542s-.192-3.4-16.679-8.642",
    fill: "#3b9f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1062",
    d: "M71.803 101.485a31.705 31.705 0 0 1-3.424-3.226c-3.285-3.966-5.619-8.654-.7-10.451.033-5.075 4.994-3.1 4.994-3.1a29.43 29.43 0 0 0 6.6 4.559 23.749 23.749 0 0 0-7.468 12.215",
    fill: "#242929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1063",
    d: "M74.868 98.779s-1.662 1.461-1.179 2.748 7.3 6.623 9.178 6.87-.293-4.723-2.81-7.251-4.06-3-5.189-2.367",
    fill: "#a6d7b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1064",
    d: "M72.559 85.653a3.706 3.706 0 0 0-2.629-.594c-1.192.363-1.3 2.061-.287 3.676-1.4-.393-2.643 1.151-1.838 3.756s4 3.155 6.273.564 3.372-4.081 1.931-5.041-3.451-2.361-3.451-2.361",
    fill: "#4b5a6b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1065",
    d: "M73.085 86.321s-1.361-1.246-2.46-1.1-1.149 1.923.668 2.588 2.951-.507 1.792-1.493",
    fill: "#7e8390"
  }))))))));
};
export default SvgOinqtip;